import { LABELS } from '@/constants/common/message.constants'

import { type TruckSpecificationEntity } from '../..'

/**
 * 荷台高さ種別
 */
export type CargoAreaHeightType = Exclude<
  TruckSpecificationEntity['cargoAreaHeightType'],
  null
>

export const CARGO_AREA_HEIGHT_TYPE = {
  /** 低床4軸 */
  LOW_FLOOR: 'LOW_FLOOR',
  /** 中低床 */
  MIDDLE_LOW_FLOOR: 'MIDDLE_LOW_FLOOR',
  /** 高床 */
  HIGH_FLOOR: 'HIGH_FLOOR'
} as const satisfies Record<CargoAreaHeightType, CargoAreaHeightType>

export const CARGO_AREA_HEIGHT_TYPE_LABEL = {
  [CARGO_AREA_HEIGHT_TYPE.LOW_FLOOR]: LABELS.LOW_FLOOR,
  [CARGO_AREA_HEIGHT_TYPE.MIDDLE_LOW_FLOOR]: LABELS.MIDDLE_LOW_FLOOR,
  [CARGO_AREA_HEIGHT_TYPE.HIGH_FLOOR]: LABELS.HIGH_FLOOR
} as const satisfies Record<CargoAreaHeightType, string>
